<template>
  <div class="error-page">
    <div class="error-page__inner">
      <picture v-if="errorData?.image">
        <source :srcset="require(`~/assets/new-design/img/error/${errorData.image}.webp`)" />
        <img
          :src="require(`~/assets/new-design/img/error/${errorData.image}.png`)"
          :alt="errorData.image"
          width="466"
          height="223"
          class="error-page__img"
        />
      </picture>
      <div class="error-page__content">
        <h2 class="error-page__title">{{ errorData?.title }}</h2>
        <p class="error-page__description">
          {{ errorData?.description }}
          Перейдите&nbsp;на главную страницу или&nbsp;напишите&nbsp;в&nbsp;нашу
          техподдержку
        </p>
      </div>
      <div class="error-page__buttons">
        <VButtonLinkMTS href="/" class="--xl --violet-gradient"
          >На главную страницу</VButtonLinkMTS
        >
        <VButtonMTS class="--xl --grey" @click="openCarrotQuest"
          >Написать в техподдержку</VButtonMTS
        >
      </div>
    </div>
  </div>
</template>
<script>
import VButtonLinkMTS from '@/components/Common/MTS/VButtonLinkMTS.vue'
import VButtonMTS from '@/components/Common/MTS/VButtonMTS.vue'
import ErrorPageMixin from '@/components/NewDesign/Page/Error/mixins/ErrorPageMixin'
import openCarrotQuest from '@/helpers/openCarrotQuest'

export default {
  name: 'ErrorPage',
  components: { VButtonMTS, VButtonLinkMTS },
  mixins: [ErrorPageMixin],
  props: {
    error: {
      type: Object,
    },
  },
  setup() {
    return {
      openCarrotQuest
    }
  }
}
</script>
<style lang="scss" scoped>
.error-page {
  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 64px 20px 128px;

    @include screen-down('sm') {
      padding: 32px 20px 64px;
    }
  }

  &__img {
    @include screen-down('md') {
      max-width: 412px;
    }

    @include screen-down('sm') {
      max-width: 245px;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 484px;
    margin-top: 40px;
    font-family: $font-mts-compact;
    text-align: center;

    @include screen-down('md') {
      max-width: 616px;
    }

    @include screen-down('sm') {
      margin-top: 32px;
    }
  }

  &__title {
    font-size: 32px;
    line-height: 36px;
    font-weight: 500;
    color: $color-dark-2;

    @include screen-down('sm') {
      font-size: 24px;
      line-height: 28px;
    }
  }

  &__description {
    font-size: 20px;
    line-height: 28px;
    color: $color-gray-1;

    @include screen-down('sm') {
      font-size: 17px;
      line-height: 24px;
    }
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    margin-top: 32px;

    @include screen-down('md') {
      margin-top: 40px;
    }

    @include screen-down('sm') {
      gap: 16px;
      margin-top: 32px;
    }
  }

  &::v-deep .v-button-link-mts.--xl,
  &::v-deep .v-button-mts.--xl {
    min-width: 308px;
    width: initial;
    padding: 14px;

    @include screen-down(480px) {
      min-width: initial;
      width: 100%;
    }
  }
}
</style>
